"use client";
import { buildProvider } from "@jb-manage-trips/config";
import type { ManageTripsApiConfig as Config } from "@jb-manage-trips/types/config";

const { ClientConfigProvider, useConfig } = buildProvider<Config>();

export { ClientConfigProvider, useConfig };
